<template>
  <div class="content-container">
    <div class="order-info">
      <div class="info-item">有线GPS: {{ orderCompact.gps }}</div>
      <div class="info-item">无线GPS1: {{ orderCompact.gps1 }}</div>
      <div class="info-item">无线GPS2: {{ orderCompact.gps2 }}</div>
      <div class="info-item">无线GPS3: {{ orderCompact.gps3 }}</div>
      <div class="info-item">备注: {{ orderCompact.description }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "OrderCompact",
  props: {
    orderCompact: {
      type: Object,
      required: true
    }
  },
  computed: {}
}
</script>

<style scoped>
.content-container {
  max-height: calc(100vh - 250px);
  min-height: 300px;
  overflow-y: auto;
}

.order-info {
  display: flex;
  flex-wrap: wrap;
}

.info-item {
  flex-basis: calc(33.333% - 20px);
  box-sizing: border-box;
  min-width: 200px;
  margin: 10px;
}
</style>

